import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Swapnendu Banerjee </span>
            from <span className="purple">Kolkata, West Bengal.</span>
            <br />
            I am currently a pre-final year student at RCC Institute of Information Technology.
            <br />
            I am currently enrolled in the Bachelor of Technology program in Computer Science and Engineering.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Listening to music
            </li>
            <li className="about-activity">
              <ImPointRight /> Hang out with friends
            </li>
            
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Learn and Earn"{" "}
          </p>
          <footer className="blockquote-footer">Swapnendu</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
